import { Component, OnInit } from '@angular/core';
import { OfflineOptions, ControlAnchor, NavigationControlType } from 'angular2-baidu-map';
import { CompanyService } from './company.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { MessageService } from '../../core/services/message.service';
import { LoginUserService } from '../../core/services/login-user.service';
import { BACKEND_API_URL } from '../../core/services/CusHttp';
import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  providers: [CompanyService],
})
export class CompanyComponent implements OnInit {
  public companyId: string;
  public companyInfoData: any = {};  //公司详情信息
  public recommendJobData: any;  //推荐岗位
  public dynamicData: any = {};// 公司简历 岗位 信息处理动态数据
  public companyJobData: any = [];//公司岗位信息
  public jobPage: any;  //岗位分页
  public longitude: any;//经纬度
  public latitude: any;//经纬度
  public opts: any;  //地址配置
  offlineOpts: OfflineOptions;   //地址配置
  public facorType: string = '0';//1 收藏   0 取消收藏
  public imgUrl = BACKEND_API_URL;
  constructor(
    public _companyServe: CompanyService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _collectService: MessageService,
    private _login: LoginUserService,
    private _title: Title,
    private _meta: Meta
  ) { }

  ngOnInit() {
    this.companyId = parseInt(this._route.snapshot.params['id']).toString();//获取漏油参数  id
    window.scrollTo(0, 0);//页面回到顶部
    this.getrecommedData();   //推荐企业 recommendJobData
    this.getCompanyData(this.companyId); //获取公司信息
    this.postCompanyBrowses();  // postCompanyBrowsesData  增加企业浏览量


    let stuID = this._login.getLoginInfo()['student_id'];
    if (stuID) {
      this._companyServe.checkStuFacorCompany(stuID, this.companyId).then(resp => {
        if (resp['data']['data']) {
          this.facorType = '1';
        } else {
          this.facorType = '0';
        }
      })
    }



  }
  // 增加企业浏览量
  postCompanyBrowses() {
    this._companyServe.postCompanyBrowsesData(this.companyId).then(resp => {
      // console.log("浏览量", resp);
    });
  }

  //获取公司信息
  getCompanyData(did: string) {  //did是需要传入的公司id
    this._companyServe.getCompanyDatailData(did).then(resp => {
      if (resp.success) {
        this.companyInfoData = resp['data']; //请求成功赋值给企业对象



        this._title.setTitle(this.companyInfoData.company_name + '招聘信息-C实习大学生实习招聘就业平台！');
        this._meta.updateTag({ name: 'Keywords', content: this.companyInfoData.industry.name + '招聘，大学生实习招聘，C实习。' });
        this._meta.updateTag({
          name: 'Description',
          content: `C实习为大学实习生提供全方位的就业支持。通过职业评测，在线课程，实训实战任务，电商大赛等方式提高大学生能力，获得相应的技能勋章，
          完成能力认证。 同时帮助大学实习生做好:职业规划、个人简历制作，实习报告、实习心得等等，服务于职场新人，提升综合就业能力。`
        });



        //如果收到经纬度，显示地图
        this.latitude = this.companyInfoData['latitude'];
        this.longitude = this.companyInfoData['longitude'];
        this.getDynamicData(this.companyId); //动态数据展示
        this.getCompanyJobList(this.companyId, );//  企业岗位列表函数
        this.dynamicData['company_browses'] = this.companyInfoData['company_browses'];
        // this.getBroweseData();  //企业岗位信息浏览量
        if (this.latitude || this.longitude) {
          this.showMap();   //地图调用函数
        }
      } else {
        alert(resp['msg']);//错误提示；
      }
    });
  }
  //动态数据展示
  getDynamicData(did: string) {
    this._companyServe.getDynamic(did).then(resp => {
      if (resp.success) {
        this.dynamicData = Object.assign(resp['data'], this.dynamicData);
      } else {
        alert(resp['msg']);
      }
    })
  }

  //推荐企业 recommendJobData
  getrecommedData() {   //获取推荐岗位函数
    this._companyServe.getRecommendData().then(resp => {   //请求数据
      if (resp.success) {
        this.recommendJobData = resp['data'];
        this.recommendJobData.map(row => {
          row['salary_min'] = row['salary_min'] / 1000;   //薪水数据格式处理
          row['salary_max'] = row['salary_max'] / 1000;   //薪水数据格式处理
          row['salary_min'] = parseInt(row['salary_min']);   //薪水数据格式处理
          row['salary_max'] = parseInt(row['salary_max']);  //薪水数据格式处理
        })
      } else {
        alert(resp['msg']);//错误提示
      }
    })
  }
  //  企业岗位列表函数
  getCompanyJobList(did: string, page?: number) {
    this._companyServe.getCompanyJob(did, page).then(resp => {
      if (resp.success) {
        this.companyJobData = resp['data'];
        this.jobPage = resp['pagination']['pageCount'];//分页信息
      } else {
        alert(resp['msg']);
      }
    })
  }
  //分页信息
  paginate(event) {
    let pages = event['page'] + 1;
    // console.log("pages:", pages);
    this.getCompanyJobList(this.companyId, pages);
  }
  //收藏企业
  favorCompany() {
    let stuID;
    let userInfo = this._login.getLoginInfo();  // 获取用户信息
    if (JSON.stringify(userInfo) === '{}') {
      this._collectService.warn('请登录您的账号');
      let queryObj = {};//路由参数
      queryObj['user'] = 'login';
      this._router.navigate(['/user-info/login-register'], { queryParams: queryObj });//登陆页面
    } else {
      let dd = this._login.getLoginInfo()['type'];
      if (dd === 3) {
        this._collectService.info('企业无法收藏');
      } else {
        this.facorType === '0' ? this.facorType = '1' : this.facorType = '0';
        stuID = this._login.getLoginInfo()['student_id'];
        let obj = {
          company_id: this.companyId,
          student_id: stuID,
          type: this.facorType,
        }
        this._companyServe.postStuFacorCompany(obj).then(resp => {
          if (resp.success && resp['data']) {
            if (this.facorType === '0') {
              this._collectService.success('取消收藏');
            } else {
              this._collectService.success('收藏成功');
            }
          } else {
            this._collectService.warn('收藏失败');
          }
        })
      }
      setTimeout(() => {
        this._collectService.clear();
      }, 3000);

    }

  }
  //地图调用函数
  showMap() {
    // 配置地图, 参考百度地图api
    this.opts = {
      center: { // 地图中心坐标
        longitude: this.longitude,
        latitude: this.latitude
      },
      zoom: 17, // 地图上的坐标
      markers: [{  //地图标注
        longitude: this.longitude,
        latitude: this.latitude,
        // title: '华泰汽车集团',
        // content: '朝阳区立水桥',
        autoDisplayInfoWindow: true
      }],
    };
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/company/company.component.ts